import { createSlice } from '@reduxjs/toolkit';

let counter = 0;

const toastSlice = createSlice({
  name: 'toasts',
  initialState: [], // array of { id, type, message }
  reducers: {
    pushToast: {
      reducer: (state, action) => {
        state.push(action.payload);
      },
      prepare: ({ type = 'info', message, id }) => ({
        payload: { id: id || `${Date.now()}-${counter++}`, type, message }
      })
    },
    removeToast: (state, action) => state.filter(t => t.id !== action.payload),
    clearToasts: () => [],
  }
});

export const { pushToast, removeToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;